import { render, staticRenderFns } from "./WebPartImageSetting.vue?vue&type=template&id=96055a22&"
import script from "./WebPartImageSetting.vue?vue&type=script&lang=js&"
export * from "./WebPartImageSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports